import type { VariantProps } from '@gluestack-ui/nativewind-utils'
import React from 'react'
import { View, ViewProps } from 'react-native'

import { cardStyle } from './styles'

export type CardProps = ViewProps & VariantProps<typeof cardStyle> & { className?: string }

const Card = React.forwardRef<React.ComponentRef<typeof View>, CardProps>(
  ({ className, size = 'md', variant = 'elevated', ...props }, ref) => {
    return (
      <View
        className={cardStyle({ size, variant, class: className })}
        {...props}
        ref={ref}
      />
    )
  }
)

Card.displayName = 'Card'

export { Card }
